import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { NotificationSetting, NotificationMethodEnum } from "app/containers/Features/containers/TeamSettings/container/Notification/type";
import { initialState } from "app/containers/Features/containers/TeamSettings/container/Notification/redux/initialState";

const notificationSlice = createSlice({
  name: "notificationSettingsState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    fetchNotificationsPreferences: (state) => {
      state.isLoading = true;
    },
    setNotifications: (
      state,
      action: PayloadAction<NotificationSetting[]>
    ) => {
      state.settings = action.payload;
    },
    toggleNotification: (
      state,
      action: PayloadAction<{ id: string; field: NotificationMethodEnum }>
    ) => {
      const { id, field } = action.payload;
      const setting = state.settings.find((item) => item._id === id);
      if (setting) {
        setting[field] = !setting[field];
      }
    },
  },
});

export const {
  actions,
  reducer: notificationReducer,
  name: notificationSliceName,
} = notificationSlice;
